import classicScrollAnchorsPublicAPI from '../modules/classic/scrollAnchorsPublicAPI'
import customElementsPublicAPI from '../modules/customElements/customElementsPublicAPI'
import breakpointsPublicAPI from '../modules/responsive/breakpointsPublicAPI'
import namedRangesPublicAPI from '../modules/responsive/namedRangesPublicAPI'
import responsivePublicAPI from '../modules/responsive/responsivePublicAPI'
import responsiveStylesPublicAPI from '../modules/responsive/responsiveStylesPublicAPI'
import scrollAnchorsPublicAPI from '../modules/responsive/scrollAnchorsPublicAPI'
import variantsPublicAPI from '../modules/variants/variantsPublicAPI'
import accessibilityPublicAPI from './definitions/accessibilityPublicAPI'
import accountPublicAPI from './definitions/accountPublicAPI'
import actionsAndBehaviorsPublicAPI from './definitions/actionsAndBehaviorsPublicAPI'
import appControllerDataPublicAPI from './definitions/appControllerDataPublicAPI'
import appStudioPublicAPI from './definitions/appStudioPublicAPI'
import appStudioWidgetsPublicAPI from './definitions/appStudioWidgetsPublicAPI'
import atomicScopesPublicAPI from './definitions/atomicScopesPublicAPI'
import autosavePublicAPI from './definitions/autosavePublicAPI'
import biPublicAPI from './definitions/biPublicAPI'
import browserThemeColorPublicAPI from './definitions/browserThemeColorPublicAPI'
import componentDetectorPublicAPI from './definitions/componentDetectorPublicAPI'
import componentPublicAPI from './definitions/componentPublicAPI'
import innerElementsPublicAPI from './definitions/innerElementsPublicAPI'
import componentsLoaderPublicAPI from './definitions/componentsLoaderPublicAPI'
import optimusMigrationPublicAPI from './definitions/optimusMigrationPublicAPI'
import componentsMetaDataPublicAPI from './definitions/componentsMetaDataPublicAPI'
import componentStylePublicAPI from './definitions/componentStylePublicAPI'
import connectionsPublicAPI from './definitions/connectionsPublicAPI'
import dataModelPublicAPI from './definitions/dataModelPublicAPI'
import debugPublicAPI from './definitions/debugPublicAPI'
import deprecationPublicAPI from './definitions/deprecationPublicAPI'
import documentModePublicAPI from './definitions/documentModePublicAPI'
import environmentPublicAPI from './definitions/environmentPublicAPI'
import errorsPublicAPI from './definitions/errorsPublicAPI'
import featuresPublicAPI from './definitions/featuresPublicAPI'
import slotsPublicAPI from './definitions/slotsPublicAPI'
import feedbackPublicAPI from './definitions/feedbackPublicAPI'
import fontsPublicAPI from './definitions/fontsPublicAPI'
import inlinePopupPublicAPI from './definitions/inlinePopupPublicAPI'
import layoutersPublicAPI from './definitions/layoutersPublicAPI'
import mediaPublicAPI from './definitions/mediaPublicAPI'
import menuPublicAPI from './definitions/menuPublicAPI'
import miniSitePublicAPI from './definitions/miniSitePublicAPI'
import mobileMigrationAPI from './definitions/mobileMigrationAPI'
import mobilePublicAPI from './definitions/mobilePublicAPI'
import multilingualPublicAPI from './definitions/multilingualPublicAPI'
import pagePublicAPI from './definitions/pagePublicAPI'
import pagesGroupPublicAPI from './definitions/pagesGroupPublicAPI'
import partnersPublicAPI from './definitions/partnersPublicAPI'
import platformPublicAPI from './definitions/platformPublicAPI'
import reactionsPublicAPI from './definitions/reactionsPublicAPI'
import refComponentPublicAPI from './definitions/refComponentPublicAPI'
import remoteStructureMetaDataPublicApi from './definitions/remoteStructureMetaDataPublicAPI'
import renderPluginsPublicApi from './definitions/renderPluginsPublicApi'
import routersPublicAPI from './definitions/routersPublicAPI'
import savePublicAPI from './definitions/savePublicAPI'
import siteMembersPublicAPI from './definitions/siteMembersPublicAPI'
import siteMetadataPublicAPI from './definitions/siteMetadataPublicAPI'
import siteSegmentsPublicAPI from './definitions/siteSegmentsPublicAPI'
import smartBoxesPublicAPI from './definitions/smartBoxesPublicAPI'
import snapshotPublicAPI from './definitions/snapshotPublicAPI'
import statesPublicAPI from './definitions/statesPublicAPI'
import structurePublicAPI from './definitions/structurePublicAPI'
import stylableEditorPublicAPI from './definitions/stylableEditorPublicAPI'
import themePublicAPI from './definitions/themePublicAPI'
import themeCssVariablesPublicAPI from './definitions/themeCssVariablesPublicAPI'
import globalStylesPublicAPI from './definitions/globalStylesPublicAPI'
import globalComponentsPublicAPI from './definitions/globalComponentsPublicAPI'
import forwardRefPublicAPI from './definitions/forwardRefPublicAPI'
import cssStylePublicAPI from './definitions/cssStylePublicAPI'
import tpaPublicAPI from './definitions/tpaPublicAPI'
import transformationsPublicAPI from './definitions/transformationsPublicAPI'
import transitionsPublicAPI from './definitions/transitionsPublicAPI'
import triggersPublicAPI from './definitions/triggersPublicAPI'
import wix2xPublicAPI from './definitions/wix2xPublicAPI'
import wixappsPublicAPI from './definitions/wixappsPublicAPI'
import wixCodePublicAPI from './definitions/wixCodePublicAPI'
import cmsPublicAPI from './definitions/cmsPublicAPI'
import variablesPublicAPI from './definitions/variablesPublicAPI'
import scopesPublicAPI from './definitions/scopesPublicAPI'
import patternsPublicAPI from './definitions/patternsPublicAPI'
import effectsPublicAPI from './definitions/effectsPublicAPI'
import sectionOrderPublicAPI from './definitions/sectionOrderPublicAPI'
import deprecatedOldBadPerformancePublicAPI from './definitions/deprecatedOldBadPerformancePublicAPI'
import classicResponsiveLayoutPublicAPI from './definitions/classicResponsiveLayoutPublicAPI'
import customCSSPublicAPI from './definitions/customCSSPublicAPI'
import aiPublicAPI from './definitions/aiPublicAPI'
import externalComponentsPublicAPI from './definitions/externalComponentsPublicAPI'
import importExportPublicAPI from './definitions/importExportPublicAPI'
import responsiveFixersPublicAPI from './definitions/responsiveFixersPublicAPI'
import builderComponentsPublicAPI from './definitions/builderComponentsPublicAPI'
import localEditorPublicAPI from './definitions/localEditorPublicAPI'
import historyAPI from './definitions/historyAPI'
import mobileAlgoPublicApi from './definitions/mobileAlgoPublicApi'
import responsiveBreakpointsDataPublicAPI from './definitions/responsiveBreakpointsDataPublicAPI'
import branchesPublicAPI from './definitions/branchesPublicAPI'
import editorFeaturesPublicAPI from './definitions/editorFeaturesPublicAPI'
import observablesPublicAPI from './definitions/observablesPublicAPI'
import contextsPublicAPI from './definitions/contextsPublicAPI'
import bindingsPublicAPI from './definitions/bindingsPublicAPI'
import {localesPublicAPI} from './definitions/localesPublicAPI'
import {runtimeBindingsPublicAPI} from './definitions/runtimeBindingsPublicAPI'

export const fullAPI = {
    branchesPublicAPI,
    accountPublicAPI,
    accessibilityPublicAPI,
    actionsAndBehaviorsPublicAPI,
    appControllerDataPublicAPI,
    appStudioPublicAPI,
    appStudioWidgetsPublicAPI,
    autosavePublicAPI,
    biPublicAPI,
    environmentPublicAPI,
    breakpointsPublicAPI,
    namedRangesPublicAPI,
    browserThemeColorPublicAPI,
    componentDetectorPublicAPI,
    componentPublicAPI,
    innerElementsPublicAPI,
    refComponentPublicAPI,
    remoteStructureMetaDataPublicApi,
    componentStylePublicAPI,
    componentsLoaderPublicAPI,
    componentsMetaDataPublicAPI,
    transformationsPublicAPI,
    transitionsPublicAPI,
    connectionsPublicAPI,
    dataModelPublicAPI,
    featuresPublicAPI,
    statesPublicAPI,
    triggersPublicAPI,
    reactionsPublicAPI,
    debugPublicAPI,
    deprecationPublicAPI,
    documentModePublicAPI,
    errorsPublicAPI,
    feedbackPublicAPI,
    fontsPublicAPI,
    slotsPublicAPI,
    atomicScopesPublicAPI,
    inlinePopupPublicAPI,
    layoutersPublicAPI,
    mediaPublicAPI,
    menuPublicAPI,
    miniSitePublicAPI,
    mobilePublicAPI,
    pagePublicAPI,
    pagesGroupPublicAPI,
    platformPublicAPI,
    renderPluginsPublicApi,
    customElementsPublicAPI,
    responsivePublicAPI,
    responsiveStylesPublicAPI,
    variantsPublicAPI,
    scrollAnchorsPublicAPI,
    sectionOrderPublicAPI,
    classicScrollAnchorsPublicAPI,
    routersPublicAPI,
    savePublicAPI,
    snapshotPublicAPI,
    siteMembersPublicAPI,
    siteMetadataPublicAPI,
    siteSegmentsPublicAPI,
    smartBoxesPublicAPI,
    structurePublicAPI,
    stylableEditorPublicAPI,
    themePublicAPI,
    themeCssVariablesPublicAPI,
    globalStylesPublicAPI,
    globalComponentsPublicAPI,
    forwardRefPublicAPI,
    optimusMigrationPublicAPI,
    cssStylePublicAPI,
    tpaPublicAPI,
    wixappsPublicAPI,
    wixCodePublicAPI,
    cmsPublicAPI,
    multilingualPublicAPI,
    localesPublicAPI,
    wix2xPublicAPI,
    partnersPublicAPI,
    mobileMigrationAPI,
    variablesPublicAPI,
    scopesPublicAPI,
    patternsPublicAPI,
    effectsPublicAPI,
    deprecatedOldBadPerformancePublicAPI,
    classicResponsiveLayoutPublicAPI,
    customCSSPublicAPI,
    aiPublicAPI,
    externalComponentsPublicAPI,
    importExportPublicAPI,
    responsiveFixersPublicAPI,
    builderComponentsPublicAPI,
    localEditorPublicAPI,
    historyAPI,
    mobileAlgoPublicApi,
    responsiveBreakpointsDataPublicAPI,
    editorFeaturesPublicAPI,
    observablesPublicAPI,
    contextsPublicAPI,
    bindingsPublicAPI,
    runtimeBindingsPublicAPI
}
